import { query } from "express";
import { runInnerFunction } from "../../compatManager";
import proxyRequest from "../../lib/proxyRequest";
import { RPWDataReader, getDataReader } from "../../livedataFuncs";
import { ProvincesShortCode } from "../navigationTypes";
import { TaskMsg, TaskResult } from "./BGTask";
import { request } from "http";

type LawyerVerify = {
    LicenseStatus: string,
    DirectPhone: string,
    Fax: string,
    FirmName: string,
    Email?: string,
    Address?: Record<string, string>,
}
namespace VerifyLawyer {
    export async function SearchLawSociety(
        province: ProvincesShortCode,
        firmId: number,
        AppID: string,
        sid: string,
        dataroot
    ) {
        const DataReaderObj: RPWDataReader = getDataReader(dataroot);
        const lawyerName = DataReaderObj.getParsedName("getOtherSideLawyerName");
        if (!lawyerName || (!lawyerName.firstname && !lawyerName.lastname)) {
            throw "Solicitor Info is not available";
        }
        const urlQuery = `SessionID=${sid}&name=Lawyer Verification&id=${AppID}`;
        try {
            const response = await fetch(`/${process.env.REACT_APP_RWAPI_ENDPOINT}/api/${province}/${firmId}/lastBGTask?${urlQuery}`);
            const lastCheck = await response.json();
            if (lastCheck && lastCheck.ok && lastCheck.result === DataReaderObj.getOtherSideLawyerName()) {
                // don't need to check as the lawyer is still the same as last checking
                return new Promise((resolve: (value: TaskResult) => void) => {
                    const blankResult: TaskResult = {
                        task_name: "Lawyer Verification",
                        task_search: "",
                        task_msgs: []
                    };
                    resolve(blankResult);
                })
            }
        } catch (e) {
            console.log(e);
        }

        // start verification
        switch (province) {
            case "ON":
                return ON_Search(dataroot, sid);
            // case "AB":
            //     return await AB_Search(dataroot, sid);
            // case "SK":
            //     return await SK_Search(dataroot, sid);
            // case "BC":
            //     return await BC_Search(dataroot, sid);
            default:
                return new Promise((resolve: (value: TaskResult) => void) => {
                    const blankResult: TaskResult = {
                        task_name: "Lawyer Verification",
                        task_search: "",
                        task_msgs: []
                    };
                    resolve(blankResult);
                })
        }
    }

    function ON_Search(dataroot, sid): Promise<TaskResult> {
        const DataReaderObj: RPWDataReader = getDataReader(dataroot);
        const lawyerName = DataReaderObj.getParsedName("getOtherSideLawyerName");
        const TaskResult: TaskResult = {
            task_name: "Lawyer Verification",
            task_search: DataReaderObj.getOtherSideLawyerName(),
            task_msgs: []
        }
        const url = "https://lawsocietyontario.search.windows.net/indexes/lsolpindexprd/docs/search?api-version=2017-11-11";
        const firstNameFilter = lawyerName.firstname ? 
            (lawyerName.firstname.includes('-') ? 
                // For hyphenated first names, search for the first part
                "search.ismatch('/.*" + lawyerName.firstname.split('-')[0] + ".*/', 'memberfirstname,membermiddlename,membermailname,memberfirstnameclean,membermiddlenameclean,membermailnameclean', 'full', 'all')" :
                // For regular names, use the original logic
                "search.ismatch('/.*" + lawyerName.firstname + ".*/', 'memberfirstname,membermiddlename,membermailname,memberfirstnameclean,membermiddlenameclean,membermailnameclean', 'full', 'all')"
            ) : "";
        const lastNameFilter = lawyerName.lastname ? 
            (lawyerName.lastname.includes('-') ? 
                // For hyphenated names, search for both parts
                "search.ismatch('/.*" + lawyerName.lastname.split('-')[1] + ".*/', 'memberlastname,memberlastnameclean', 'full', 'all')" :
                // For regular names, use the original logic
                "search.ismatch('/.*" + lawyerName.lastname + ".*/', 'memberlastname,memberlastnameclean', 'full', 'all')"
            ) : "";
        const filter = [firstNameFilter, lastNameFilter].join(" and ");

        const requestBody = {
            search: "*",
            filter: filter,
            facets: ["memberareasofservicenamesenglish,count:50,sort:value", "memberlanguagenamesenglish,count:50,sort:value", "memberwebstatus,count:50,sort:value", "membercity,count:50,sort:count"],
            count: true,
            top: 10000,
            skip: 0,
            orderby: "memberlastname, memberfirstname, membermiddlename",
            queryType: "full",
            searchFields: "memberfirstname,membermiddlename,memberfullname,membermailname,memberfirstnameclean,membermiddlenameclean,memberlastnameclean,membermailnameclean"
        }

        // The site does a ping to get the api-key I think, may need to change this eventually but the
        // api-key seems to stay the same currently
        const headers = {
            'Content-Type': 'application/json',
            'api-key': '212D535962D4563E62F8EC5D6E1C71CA',
            'Host': 'lawsocietyontario.search.windows.net',
            'Connection': 'keep-alive',
            'Content-Length': '511',
            'Pragma': 'no-cache',
            'Cache-Control': 'no-cache',
            'sec-ch-ua': '" Not A;Brand";v="99", "Chromium";v="99", "Google Chrome";v="99"',
            'sec-ch-ua-mobile': '?0',
            'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/99.0.4844.82 Safari/537.36',
            'Accept': 'application/json',
            'sec-ch-ua-platform': '"Windows"',
            'Origin': 'https://lso.ca',
            'Sec-Fetch-Site': 'cross-site',
            'Sec-Fetch-Mode': 'cors',
            'Sec-Fetch-Dest': 'empty',
            'Referer': 'https://lso.ca/',
            'Accept-Encoding': 'gzip, deflate, br',
            'Accept-Language': 'en-US,en;q=0.9'
        };
        return proxyRequest({ url: url, requestBody: requestBody, headers: headers }, sid).then(async response => {
            const foundLawyerList = JSON.parse(response).value;
            const matchReg = new RegExp(`${lawyerName.firstname}\\s${lawyerName.middlename ? `(\\S*\\s*)*${lawyerName.middlename}\\S*\\s` : ''}(\\S*\\s*)*${lawyerName.lastname}`);
            // Temp fix for BUG-18085. don't try to match names with over 4 space separated sections to prevent regex match from taking extremely long
            const lawyerIndex = foundLawyerList.findIndex(member => {
                if (!member.memberfullname || member.memberfullname.split(" ").length > 4) {
                    // console.log("skipped matching", member.memberfullname)
                    return null
                }
                return member.memberfullname.match(matchReg);
            });
            if (lawyerIndex === -1) {
                TaskResult.task_msgs.push({
                    text: `No LSO directory match for lawyer ${lawyerName.firstname} ${lawyerName.lastname}`,
                    flag: "Red",
                    RWValue: "",
                    SearchValue: ""
                });
                return TaskResult;
            }
            
            // Check if foundLawyerList[lawyerIndex] exists and validate name and status
            if (foundLawyerList[lawyerIndex]) {
                const lawyerFullName = DataReaderObj.getOtherSideLawyerName();
                const expectedName = `${lawyerName.firstname}${lawyerName.middlename ? ` ${lawyerName.middlename}` : ''} ${lawyerName.lastname}`.trim();
                
                // Check if name doesn't match
                if (foundLawyerList[lawyerIndex].memberfullname !== expectedName) {
                    TaskResult.task_msgs.push({
                        text: `Name`,
                        flag: "Yellow",
                        RWValue: lawyerFullName,
                        SearchValue: foundLawyerList[lawyerIndex].memberfullname
                    });
                }
                
                // Check web status against YellowFlagStatuses
                const YellowFlagStatuses = [
                    "In Private Practice (Practice Restricted)",
                    "Practice Restricted",
                    "Licensee Participating in PBLO (PBLO Emeritus Lawyer)",
                    "Practising Law - Canadian Legal Advisor",
                    "To Be Confirmed"
                ];
                
                if (foundLawyerList[lawyerIndex].memberwebstatus && 
                    foundLawyerList[lawyerIndex].memberwebstatus[0] && 
                    YellowFlagStatuses.indexOf(foundLawyerList[lawyerIndex].memberwebstatus[0]) !== -1) {
                    TaskResult.task_msgs.push({
                        text: `The status of law practice (${foundLawyerList[lawyerIndex].memberwebstatus[0]})`,
                        flag: "Yellow",
                        RWValue: "",
                        SearchValue: foundLawyerList[lawyerIndex].memberwebstatus[0]
                    });
                }

                const RedFlagStatuses = [
                    "Not Practising Law - Employed",
                    "Not Practising Law",
                    "Suspended Administratively",
                    "Suspended",
                    "Undertaking Not to Practise",
                    "Deceased",
                    "Licence Surrendered - By Order of the Law Society Tribunal",
                    "Licence Surrendered - Administrative Surrender of Licence",
                    "Licence Surrendered - Retired",
                    "Licence Surrendered - In the Face of Regulatory Proceedings",
                    "Licence Revoked",
                    "Licence Revoked - Administrative Suspension Over 12 Months",
                    "Licence Revoked - Regulatory Suspension Over 24 Months",
                    "Trusteeship"
                ];

                if (foundLawyerList[lawyerIndex].memberwebstatus && 
                    foundLawyerList[lawyerIndex].memberwebstatus[0] && 
                    RedFlagStatuses.indexOf(foundLawyerList[lawyerIndex].memberwebstatus[0]) !== -1) {
                    TaskResult.task_msgs.push({
                        text: `The status of law practice (${foundLawyerList[lawyerIndex].memberwebstatus[0]})`,
                        flag: "Red",
                        RWValue: "",
                        SearchValue: foundLawyerList[lawyerIndex].memberwebstatus[0]
                    });
                }
            }
            
            //`/browserapi/proxy?SessionID=${sid}` with impit implement. save for BACKUP and DO NOT add it back unless instructed specifically
            // const lawyerUrl = `https://lso.ca/public-resources/finding-a-lawyer-or-paralegal/directory-search/member?MemberNumber=${foundLawyerList[lawyerIndex].membernumber}`;
            // TaskResult.task_link = lawyerUrl;
            // const proxyRequestBody = {
            //     method: "GET",
            //     url: lawyerUrl,
            //     manageSession: true,
            //     impersonate: true,
            //     impersonateBrowser: "chrome",
            // };
            // try {
            //     const lawyerInfoResponse = await fetch(`/browserapi/proxy?SessionID=${sid}`, {
            //         method: "POST",
            //         headers: { "Content-Type": "application/json" },
            //         body: JSON.stringify(proxyRequestBody)
            //     });
                
            //     if (lawyerInfoResponse.ok) {
            //         const responseJson = await lawyerInfoResponse.json();
            //         if (responseJson.ok && responseJson.result && responseJson.result.ok) {
            //             const html = responseJson.result.response;
            //             const parsedLawyer = runInnerFunction("ReactShell.ONParseLSOHTML", html);
            //             const detailedChecks = ON_Check(parsedLawyer, DataReaderObj);
            //             TaskResult.task_msgs = [...TaskResult.task_msgs, ...detailedChecks];
            //         } else {
            //             const errorMsg = (responseJson.result && responseJson.result.response) || "Proxy service failed to fetch page.";
            //             console.error("Proxy fetch error: ", errorMsg);
            //         }
            //     } else {
            //         console.error("Network error calling proxy service:", lawyerInfoResponse.statusText);
            //     }
            // } catch(error) {
            //     const errorMsg = (error && typeof error === 'object' && 'message' in error) ? (error as Error).message : String(error);
            //     console.error("Exception while fetching lawyer details via proxy:", errorMsg);
            // }
            return TaskResult;
        })
    }

    //Keeping the check functions here in case we come back to this 

    function ON_Check(parsedLawyer, DataReaderObj: RPWDataReader): TaskMsg[] {
        const TaskMsgs: TaskMsg[] = [];
        // Licensestatus
        const RedFlagStatuses = [
            "Not Practising Law - Employed",
            "Not Practising Law",
            "Suspended Administratively",
            "Suspended",
            "Undertaking Not to Practise",
            "Deceased",
            "Licence Surrendered - By Order of the Law Society Tribunal",
            "Licence Surrendered - Administrative Surrender of Licence",
            "Licence Surrendered - Retired",
            "Licence Surrendered - In the Face of Regulatory Proceedings",
            "Licence Revoked",
            "Licence Revoked - Administrative Suspension Over 12 Months",
            "Licence Revoked - Regulatory Suspension Over 24 Months",
            "Trusteeship"
        ];
        const YellowFlagStatuses = [
            "In Private Practice (Practice Restricted)",
            "In Private Practice",
            "Practice Restricted",
            "Licensee Participating in PBLO (PBLO Emeritus Lawyer)",
            "Practising Law - Canadian Legal Advisor",
            "To Be Confirmed"
        ];
        if (RedFlagStatuses.indexOf(parsedLawyer["LicenseStatus"]) !== -1) {
            TaskMsgs.push({
                text: `The status of law practice (${parsedLawyer["LicenseStatus"]})`,
                flag: "Red",
                RWValue: "",
                SearchValue: parsedLawyer["LicenseStatus"]
            })
        } else if (YellowFlagStatuses.indexOf(parsedLawyer["LicenseStatus"]) !== -1) {
            TaskMsgs.push({
                text: `The status of law practice (${parsedLawyer["LicenseStatus"]})`,
                flag: "Yellow",
                RWValue: "",
                SearchValue: parsedLawyer["LicenseStatus"]
            })
        }

        // Name
        const lawyerFullName = DataReaderObj.getOtherSideLawyerName();
        if (lawyerFullName !== parsedLawyer["Name"]) {
            TaskMsgs.push({
                text: `Name`,
                flag: "Yellow",
                RWValue: lawyerFullName,
                SearchValue: parsedLawyer["Name"]
            })
        }

        // Phone
        const phone = DataReaderObj.getOtherSideLawyerField("DirectPhone");
        if (parsedLawyer["DirectPhone"] && phone !== parsedLawyer["DirectPhone"]) {
            TaskMsgs.push({
                text: `Phone`,
                flag: "Yellow",
                RWValue: phone,
                SearchValue: parsedLawyer["DirectPhone"]
            })
        }

        // Fax
        const fax = DataReaderObj.getOtherSideLawyerField("Fax");
        if (parsedLawyer["Fax"] && fax !== parsedLawyer["Fax"]) {
            TaskMsgs.push({
                text: `Fax`,
                flag: "Yellow",
                RWValue: fax,
                SearchValue: parsedLawyer["Fax"]
            })
        }

        // Email
        const email = DataReaderObj.getOtherSideLawyerField("FirmEmail").trim();
        if (parsedLawyer["FirmEmail"] && email !== parsedLawyer["FirmEmail"]) {
            TaskMsgs.push({
                text: `Email`,
                flag: "Yellow",
                RWValue: email,
                SearchValue: parsedLawyer["FirmEmail"]
            })
        }
        // Insured
        if(parsedLawyer["Insured"].toLowerCase().trim() !== "yes") {
            TaskMsgs.push({
                text: `Real Estate Insured`,
                flag: "Yellow",
                RWValue: "No",
                SearchValue: parsedLawyer["Insured"]
            })
        }
        return TaskMsgs;
    }
    async function BC_Search(dataroot, sid): Promise<TaskResult> {
        const DataReaderObj: RPWDataReader = getDataReader(dataroot);
        const lawyerName = DataReaderObj.getParsedName("getOtherSideLawyerName");
        const lawyerTown = DataReaderObj.getOtherSideLawyerField("NewAddressLine2");
        let url = "https://www.lawsociety.bc.ca/lsbc/apps/lkup/directory/mbr-search.cfm?txt_search_type=1";
        let requestBody = "&txt_last_nm=" + lawyerName.lastname + "&txt_given_nm=" + lawyerName.firstname + "&txt_city=" + lawyerTown + "&member_search=Search&is_submitted=1&results_no=10#act_searchresults";
        const TaskResult: TaskResult = {
            task_name: "Lawyer Verification",
            task_search: DataReaderObj.getOtherSideLawyerName(),
            task_msgs: []
        }
        let headers = {
            "Content-Type": null,
            "Cookie": null,
            "Referer": null,
            "User-Agent": "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; rv:11.0) like Gecko"
        }
        TaskResult.task_link = url + "?" + requestBody;
        url += requestBody;
        return proxyRequest({ url: url, requestBody: requestBody, headers: headers, isJSON: false }, sid).then(async response => {
            let parsedLawyer: LawyerVerify = {
                LicenseStatus: "",
                DirectPhone: "",
                Fax: "",
                FirmName: "",
                Address: {},
            }
            let listHTML = runInnerFunction("ReactShell.callInnerFunctionMutlipleParams", ["getOuterAnyHTMLByPart", response, "<td data-title=\"Name\">", "TR"]);
            listHTML = listHTML.substring(listHTML.indexOf('<a href="'), listHTML.indexOf('</a>'));
            listHTML = listHTML.substring(listHTML.indexOf('"') + 1, listHTML.indexOf('">'));
            let newUrl = 'https://www.lawsociety.bc.ca/lsbc/apps/lkup/directory/' + listHTML;
            return proxyRequest({ url: newUrl, requestBody: requestBody, headers: headers, isJSON: false }, sid).then(async response => {
                let lawyerHTML = "";
                let start = response.indexOf("<h3>");
                let lawyerName = ""
                if (start != -1) {
                    lawyerName = response.substring(start + 4);
                } else {
                    start = response.indexOf("<h3 ");
                    let startText = response.substring(start + 4)
                    lawyerName = startText.substring(startText.indexOf(">") + 1);

                }
                if (lawyerName > "") {
                    lawyerName = lawyerName.substring(0, lawyerName.indexOf("</h3>"))
                    lawyerHTML += "<tr><td class=\"heading1\"></td><td><b>" + lawyerName + "</b></td></tr>";
                }
                response = runInnerFunction("ReactShell.callInnerFunctionMutlipleParams", ["getOuterAnyHTMLByPart", response, "class=\"col-sm-12\">", "DIV"]);
                while (response.indexOf("class=\"row\"") != -1) {
                    let listHTML = runInnerFunction("ReactShell.callInnerFunctionMutlipleParams", ["getOuterAnyHTMLByPart", response, "class=\"row\"", "DIV"]);
                    let theHeader = runInnerFunction("ReactShell.callInnerFunctionMutlipleParams", ["getOuterAnyHTMLByPart", listHTML, "col-sm-3", "DIV"]);
                    let theData = runInnerFunction("ReactShell.callInnerFunctionMutlipleParams", ["getOuterAnyHTMLByPart", listHTML, "col-sm-9", "DIV"]);

                    if (theHeader > "") {
                        theHeader = theHeader.substring(theHeader.indexOf(">") + 1);
                        theHeader = theHeader.substring(0, theHeader.indexOf("</div>"));
                        theHeader = runInnerFunction("TrimFull", theHeader);
                        theHeader = theHeader.replace(/(<([^>]+)>)/ig, "");

                        theData = theData.substring(theData.indexOf(">") + 1);
                        theData = theData.substring(0, theData.lastIndexOf("</div>"));
                        theData = runInnerFunction("TrimFull", theData);
                        theData = theData.replace(/(<([^>]+)>)/ig, "");
                        let matchArray = {
                            'Current status': 'LicenseStatus',
                            'Primary location': 'FirmName',
                            'Phone number': 'DirectPhone',
                            'Fax number': 'Fax'
                        }
                        try {
                            let addressArray = theData.split("\r\n");
                            if (addressArray.length > 4) {
                                if (addressArray[2].indexOf('BC') >= 0) { // no po box
                                    parsedLawyer.Address["Street"] = addressArray[0].trim();
                                    parsedLawyer.Address["City"] = addressArray[1].trim();
                                    parsedLawyer.Address["Province"] = addressArray[2].trim();
                                    parsedLawyer.Address["Postal"] = addressArray[3].trim();
                                } else if (addressArray[3].indexOf('BC') >= 0) { // po box
                                    parsedLawyer.Address["Street"] = addressArray[0].trim() + ' \r\n ' + addressArray[1].trim();
                                    parsedLawyer.Address["City"] = addressArray[2].trim();
                                    parsedLawyer.Address["Province"] = addressArray[3].trim();
                                    parsedLawyer.Address["Postal"] = addressArray[4].trim();
                                }
                            }
                        } catch (e) {  }
                        if (matchArray[theHeader] > '') {
                            parsedLawyer[matchArray[theHeader]] = theData;
                        }
                    }
                    response = response.replace("class=\"row\"", "");
                }
                parsedLawyer.DirectPhone = (parsedLawyer.DirectPhone).replace(/[^0-9.]/g, '');
                parsedLawyer.Fax = (parsedLawyer.Fax).replace(/[^0-9.]/g, '');
                TaskResult.task_msgs = await BC_Check(parsedLawyer, DataReaderObj);
                return TaskResult;
            });
        });
    }
    async function BC_Check(parsedLawyer: LawyerVerify, DataReaderObj: RPWDataReader) {
        const TaskMsgs: TaskMsg[] = [];
        // only other status I can see is Practising & Practising (Corporate/Government Counsel)
        const RedFlagStatuses = [
            "Non-Practising",
            "Retired",
            "Former member",
        ];
        // license
        if (RedFlagStatuses.indexOf(parsedLawyer["LicenseStatus"]) !== -1) {
            TaskMsgs.push({
                text: `License Status`,
                flag: RedFlagStatuses.indexOf(parsedLawyer["LicenseStatus"]) !== -1 ? "Red" : "Yellow",
                RWValue: "",
                SearchValue: parsedLawyer["LicenseStatus"]
            })
        }
        // phone number
        const phone = DataReaderObj.getOtherSideLawyerField("DirectPhone").replace(/[^0-9.]/g, '');
        if ((parsedLawyer["DirectPhone"] && phone.trim() !== parsedLawyer["DirectPhone"]) || parsedLawyer["DirectPhone"] <= '') {
            TaskMsgs.push({
                text: `Phone Number`,
                flag: "Yellow",
                RWValue: phone,
                SearchValue: parsedLawyer["DirectPhone"]
            })
        }
        // Fax
        const fax = DataReaderObj.getOtherSideLawyerField("Fax").replace(/[^0-9.]/g, '');
        if ((parsedLawyer["Fax"] && fax.trim() !== parsedLawyer["Fax"]) || parsedLawyer["Fax"] <= '') {
            TaskMsgs.push({
                text: `Fax`,
                flag: "Yellow",
                RWValue: fax,
                SearchValue: parsedLawyer["Fax"]
            })
        }
        // Firm Name
        const firmName = DataReaderObj.getOtherSideLawyerField("FirmName");
        if ((parsedLawyer["FirmName"] && firmName.toLowerCase().trim() !== parsedLawyer["FirmName"].toLocaleLowerCase().trim()) || parsedLawyer["FirmName"] <= '') {
            TaskMsgs.push({
                text: `Firm Name`,
                flag: "Yellow",
                RWValue: firmName,
                SearchValue: parsedLawyer["FirmName"]
            })
        }
        return TaskMsgs;
    }
    function AB_Search(dataroot, sid): Promise<TaskResult> {
        const DataReaderObj: RPWDataReader = getDataReader(dataroot);
        const lawyerName = DataReaderObj.getParsedName("getOtherSideLawyerName");
        const lawyerTown = DataReaderObj.getOtherSideLawyerField("NewAddressLine2");
        const TaskResult: TaskResult = {
            task_name: "Lawyer Verification",
            task_search: DataReaderObj.getOtherSideLawyerName(),
            task_msgs: []
        }
        const url = "https://lsa.memberpro.net/main/body.cfm";
        let headers = {
            'Cookie': "LANGUAGE=E; ",
            'Referer': url,
            'User-Agent': "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; rv:11.0) like Gecko",
            'Content-Type': 'application/x-www-form-urlencoded'
        }
        let requestBody = "person_nm=" + lawyerName.lastname + "&first_nm=" + lawyerName.firstname + "&location=" + lawyerTown + "&mode=search&menu=directory&submenu=directoryPractisingMember&records_perpage_qy=100";
        TaskResult.task_link = url + "?" + requestBody;
        return proxyRequest({ url: url, requestBody: requestBody, headers: headers, isJSON: false }, sid).then(async response => {
            let parsedLawyer: LawyerVerify = {
                LicenseStatus: "",
                DirectPhone: "",
                Fax: "",
                FirmName: ""
            }
            let listHTML = runInnerFunction("ReactShell.callInnerFunctionMutlipleParams", ["getOuterAnyHTMLByPart", response, "<TD CLASS=\"table-result-header\">", "TABLE"]);
            if (listHTML === "" || listHTML === undefined || listHTML === null) {
                TaskResult.task_msgs = [
                    {
                        text: `This lawyer could not be verified. Please verify this lawyer on Law Society of Alberta.`,
                        flag: "Red",
                        RWValue: "",
                        SearchValue: "person_nm=" + lawyerName.lastname + "&first_nm=" + lawyerName.firstname + "&location=" + lawyerTown + "&fullName=" + lawyerName
                    }
                ]
                return TaskResult;
            }
            let textArea = document.createElement('textarea');
            if (response.indexOf("Select the Lawyer Name to view the information") == -1) {// the only lawyer with details  
                let lawyerHTML = runInnerFunction("ReactShell.callInnerFunctionMutlipleParams", ["getOuterAnyHTMLByPart", response, " CLASS=\"content\"", "DIV"]);
                lawyerHTML = lawyerHTML.substring(0, lawyerHTML.indexOf("<SCRIPT")) + lawyerHTML.substring(lawyerHTML.indexOf("</FORM>") + 7);
                lawyerHTML = lawyerHTML.replace("Print", "");
                lawyerHTML = lawyerHTML.replace("Print", "");
                lawyerHTML = lawyerHTML.replace("Print", "");
                let lawyerElement = document.createElement('div');
                lawyerElement.innerHTML = lawyerHTML;
                let lawyerTable = lawyerElement.firstElementChild.firstElementChild.nextElementSibling;
                // practise status 
                let practisingStatus = lawyerTable.firstElementChild.firstElementChild.nextElementSibling.firstElementChild.nextElementSibling.innerHTML;
                textArea.innerHTML = practisingStatus;
                parsedLawyer.LicenseStatus = textArea.value.replace(/(\r\n|\n|\r|\t|" ")/gm, "").trim();

                try {
                    let mainTableInformation = lawyerTable.nextElementSibling.firstElementChild.firstElementChild.nextElementSibling.firstElementChild.firstElementChild.firstElementChild;
                    // office phone number
                    textArea.innerHTML = mainTableInformation.firstElementChild.nextElementSibling.firstElementChild.nextElementSibling.innerHTML;
                    parsedLawyer.DirectPhone = textArea.value.replace(/(\r\n|\n|\r|\t|" ")/gm, "").trim();
                    // fax number
                    textArea.innerHTML = mainTableInformation.firstElementChild.nextElementSibling.nextElementSibling.firstElementChild.nextElementSibling.innerHTML;
                    parsedLawyer.Fax = textArea.value.replace(/(\r\n|\n|\r|\t|" ")/gm, "").trim();
                    // firm name 
                    textArea.innerHTML = mainTableInformation.firstElementChild.firstElementChild.firstElementChild.innerHTML;
                    parsedLawyer.FirmName = textArea.value.replace(/(\r\n|\n|\r|\t|" ")/gm, "").trim();

                } catch (e) {
                    console.log(e);
                }
                TaskResult.task_msgs = AB_Check(parsedLawyer, DataReaderObj);
                return TaskResult;
            } else { // multiple lawyers, always choose the first one 
                try {
                    let lawyerListElement = document.createElement('div');
                    lawyerListElement.innerHTML = listHTML;

                    let lawyerRow = lawyerListElement.firstElementChild.firstElementChild.nextElementSibling.firstElementChild;

                    let tableID: string = ((lawyerRow.firstElementChild.firstElementChild) as HTMLAnchorElement).href.split(",")[1].replace(')', '');
                    requestBody = 'menu=directory&submenu=directoryPractisingMember&mode=search&searchField=location_nm&search_value=&record_id=1&table_id=' + tableID;
                    TaskResult.task_link = url + "?" + requestBody;
                    return proxyRequest({ url: url, requestBody: requestBody, headers: headers, isJSON: false }, sid).then(async response => {
                        let lawyerHTML = runInnerFunction("ReactShell.callInnerFunctionMutlipleParams", ["getOuterAnyHTMLByPart", response, " CLASS=\"content\"", "DIV"]);
                        lawyerHTML = lawyerHTML.substring(0, lawyerHTML.indexOf("<SCRIPT")) + lawyerHTML.substring(lawyerHTML.indexOf("</FORM>") + 7);
                        lawyerHTML = lawyerHTML.replace("Print", "");
                        lawyerHTML = lawyerHTML.replace("Print", "");
                        lawyerHTML = lawyerHTML.replace("Print", "");
                        let lawyerElement = document.createElement('div');
                        lawyerElement.innerHTML = lawyerHTML;
                        let lawyerTable = lawyerElement.firstElementChild.firstElementChild.nextElementSibling;
                        // practise status 
                        let practisingStatus = lawyerTable.firstElementChild.firstElementChild.nextElementSibling.firstElementChild.nextElementSibling.innerHTML;
                        textArea.innerHTML = practisingStatus;
                        parsedLawyer.LicenseStatus = textArea.value.replace(/(\r\n|\n|\r|\t|" ")/gm, "").trim();

                        try {
                            let mainTableInformation = lawyerTable.nextElementSibling.firstElementChild.firstElementChild.nextElementSibling.firstElementChild.firstElementChild.firstElementChild;
                            // office phone number
                            textArea.innerHTML = mainTableInformation.firstElementChild.nextElementSibling.firstElementChild.nextElementSibling.innerHTML;
                            parsedLawyer.DirectPhone = textArea.value.replace(/(\r\n|\n|\r|\t|" ")/gm, "").trim();
                            // fax number
                            textArea.innerHTML = mainTableInformation.firstElementChild.nextElementSibling.nextElementSibling.firstElementChild.nextElementSibling.innerHTML;
                            parsedLawyer.Fax = textArea.value.replace(/(\r\n|\n|\r|\t|" ")/gm, "").trim();
                            // firm name 
                            textArea.innerHTML = mainTableInformation.firstElementChild.firstElementChild.firstElementChild.innerHTML;
                            parsedLawyer.FirmName = textArea.value.replace(/(\r\n|\n|\r|\t|" ")/gm, "").trim();

                        } catch (e) {
                            console.log(e);
                        }
                        TaskResult.task_msgs = AB_Check(parsedLawyer, DataReaderObj);
                        return TaskResult;

                    });
                } catch (e) {
                    console.log(e);
                }
                return TaskResult;
            }
        })
    }
    function AB_Check(parsedLawyer: LawyerVerify, DataReaderObj: RPWDataReader): TaskMsg[] {
        const TaskMsgs: TaskMsg[] = [];
        // only other status I can see is Practising & Practising (Corporate/Government Counsel)
        const RedFlagStatuses = [
            "Inactive",
            "Administration Suspension",
            "Non-Practising",
            "Former",
            "Disbarred",
        ];
        const YellowFlagStatuses = [
            "Practising (Out of Province)",
        ];
        // license
        if (RedFlagStatuses.indexOf(parsedLawyer["LicenseStatus"]) !== -1 || YellowFlagStatuses.indexOf(parsedLawyer["LicenseStatus"]) !== -1) {
            TaskMsgs.push({
                text: `License Status`,
                flag: RedFlagStatuses.indexOf(parsedLawyer["LicenseStatus"]) !== -1 ? "Red" : "Yellow",
                RWValue: "",
                SearchValue: parsedLawyer["LicenseStatus"]
            })
        }
        // phone number
        const phone = DataReaderObj.getOtherSideLawyerField("DirectPhone");
        if ((parsedLawyer["DirectPhone"] && phone.trim() !== parsedLawyer["DirectPhone"]) || parsedLawyer["DirectPhone"] <= '') {
            TaskMsgs.push({
                text: `Phone Number`,
                flag: "Yellow",
                RWValue: phone,
                SearchValue: parsedLawyer["DirectPhone"]
            })
        }
        // Fax
        const fax = DataReaderObj.getOtherSideLawyerField("Fax");
        if ((parsedLawyer["Fax"] && fax.trim() !== parsedLawyer["Fax"]) || parsedLawyer["Fax"] <= '') {
            TaskMsgs.push({
                text: `Fax`,
                flag: "Yellow",
                RWValue: fax,
                SearchValue: parsedLawyer["Fax"]
            })
        }
        // Firm Name
        const firmName = DataReaderObj.getOtherSideLawyerField("FirmName");
        if ((parsedLawyer["FirmName"] && firmName.toLowerCase().trim() !== parsedLawyer["FirmName"].toLocaleLowerCase().trim()) || parsedLawyer["FirmName"] <= '') {
            TaskMsgs.push({
                text: `Firm Name`,
                flag: "Yellow",
                RWValue: firmName,
                SearchValue: parsedLawyer["FirmName"]
            })
        }
        return TaskMsgs;
    }
    async function SK_Search(dataroot, sid): Promise<TaskResult> {
        const DataReaderObj: RPWDataReader = getDataReader(dataroot);
        const lawyerName = DataReaderObj.getParsedName("getOtherSideLawyerName");
        let starter = "https://lss.alinityapp.com/Client/PublicDirectory";  // change url to lssv6
        let headers = {
            "Content-Type": null,
            "Cookie": null,
            "Referer": null,
            "User-Agent": "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; rv:11.0) like Gecko"
        }
        let querySID = "";
        let starterResponse = await proxyRequest({ url: starter, requestBody: null, headers: headers, isJSON: false }, sid).then(async response => {
            querySID = runInnerFunction("ReactShell.callInnerFunctionMutlipleParams", ["getOpenHTMLByUniqAttr", response, "id", "querySID"]);
            querySID = runInnerFunction("ReactShell.callInnerFunctionMutlipleParams", ["getItemAttrByName", querySID, "value"]);
        });
        let params = getSKQueryParameters(querySID, lawyerName.firstname, lawyerName.lastname);
        let middleUrl = starter + '/Registrants?' + params;
        let headersPost = {
            'Accept': '*/*',
            'Accept-Encoding': 'gzip, deflate, br',
            'Cache-Control': 'no-cache',
            'Connection': 'keep-alive',
            'Content-Type': 'application/x-www-form-urlencoded',
            'Host': 'lss.alinityapp.com',
            'Origin': 'https://lss.alinityapp.com'
        }
        let urlParam = null;
        let middleResponse = await proxyRequest({ url: middleUrl, requestBody: {}, headers: headersPost, isJSON: false }, sid).then(async response => {
            let res = JSON.parse(response);
            if (res.Records[0].rg === undefined || res.Records[0].rg === null || res.Records[0].rg === "") return {};
            urlParam = res.Records[0].rg;
        });
        if (!urlParam) return;
        let lastUrl = starter + '/Registrant/' + urlParam;
        let parsedLawyer: LawyerVerify = {
            LicenseStatus: "",
            DirectPhone: "",
            Fax: "",
            FirmName: ""
        }
        let response = await proxyRequest({ url: lastUrl, requestBody: {}, headers: headersPost, isJSON: false }, sid).then(async response => {
            let lawyerHTML = runInnerFunction("ReactShell.callInnerFunctionMutlipleParams", ["getOuterAnyHTMLByPart", response, ".main-container", "SCRIPT"]);
            let start = lawyerHTML.indexOf('$("#detailtemplate").html(),');
            let end = lawyerHTML.indexOf('$("[data-moreinfolink]").');
            let newString = lawyerHTML.substring(start + 28, (end));
            end = newString.lastIndexOf('}');
            let parsed = JSON.parse(newString.substring(0, end + 1));
            parsedLawyer.LicenseStatus = parsed.fn;
        });
        return null;
    }
    function getSKQueryParameters(querySID: string, firstname: string, lastname: string) {
        let obj = '{"Parameter": [{"ID": "TextOptionA","Value": "' + firstname + '","ValueLabel": "[not entered]"},' +
            '{"ID": "TextOptionC","Value": "' + '","ValueLabel": "[not entered]"},' +
            '{"ID": "TextOptionB","Value": "' + lastname + '","ValueLabel": "[not entered]"},' +
            '{"ID": "LanguageSID","Value": "","ValueLabel": "[not entered]"},' +
            '{"ID": "DefaultProvinceCitySID","Value": "","ValueLabel": "[not entered]"},' +
            '{"ID": "SpecializationSID","Value": "-","ValueLabel": "[not entered]"}]}';
        let param = "queryParameters=" + obj + "&querySID=" + querySID;
        return param;
    }
}

export default VerifyLawyer;